//Leads Action
export const CURRENT_LEAD = 'CURRENT_LEAD';

//Current user profile details
export const PROFILE_DETAILS = 'PROFILE_DETAILS';

// Leads Count
export const LEADS_COUNT = 'LEADS_COUNT';

// Current Member
export const CURRENT_MEMBER = 'CURRENT_MEMBER';

// Active Edit Member
export const CURRENT_EDIT_MEMBER = 'CURRENT_EDIT_MEMBER';
